import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import lyoptions from "../../images/app_bar/logo.svg";

import UserIcon from "../../images/app_bar/avatar.svg";
import PdfIcon from "../../images/app_bar/report.svg";
import PullDownPageIcon from "../../images/app_bar/drag.svg";
import DropdownUserIcon from "../../images/app_bar/user_icon.svg";
import LogoutIcon from "../../images/app_bar/logout.svg";
import ReferDarkIcon from "../../images/app_bar/refer_dark.svg";
import ReferLightIcon from "../../images/app_bar/refer.svg";
import Moon from "../../images/app_bar/dark.svg";
import Sun from "../../images/app_bar/light.svg";
import CalculatorIcon from "../../images/app_bar/calculator.svg";

import { CLIENT_ID, BROKER_NAME } from "../../utils/constants";
import { ButtonContext } from "../../context/ButtonsContext";
import { getSetting } from "../../utils/api";
import { useTheme } from "../../context/ThemeContext";
import ReferAndEarnModal from "../../modals/ReferAndEarnModal";
import ReportsModal from "../../screens/Reports/pages/ReportsPage";
import { getCookie } from "../../utils/cookieUtils";

// Custom NavLink component with active dot indicator
const CustomNavLink = ({ to, children }) => {
  return (
    <NavLink
      to={to}
      className={({ isActive }) => {
        return isActive ? "active position-relative" : "inactive";
      }}>
      {({ isActive }) => (
        <>
          {isActive && (
            <span
              style={{
                position: "absolute",
                left: "-12px",
                top: "60%",
                transform: "translateY(-50%)",
                width: "6px",
                height: "6px",
                backgroundColor: "#BCEF3F",
                borderRadius: "50%",
                display: "inline-block",
              }}
            />
          )}
          {children}
        </>
      )}
    </NavLink>
  );
};

const HeaderDesktop = ({ symbolData }) => {
  const { theme, setLightMode, setDarkMode } = useTheme();
  const navigate = useNavigate();
  const { isLive, setIsLive, setIsVirtual, toggleLive, toggleVirtual } =
    useContext(ButtonContext);
  const [settingData, setSettingData] = useState(null);
  const [showReferModal, setShowReferModal] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);

  const openModal = () => {
    setIsReportModalOpen(true);
  };

  const closeModal = () => {
    setIsReportModalOpen(false);
  };
  const openReferModal = () => {
    setShowReferModal(true);
  };

  const closeReferModal = () => {
    setShowReferModal(false);
  };
  const broker = localStorage.getItem("broker");
  const clientId = getCookie("client_id");
  const access_token = getCookie("access_token");
  const gmailUserName = localStorage.getItem("name");
  const auth_code = localStorage.getItem("auth_code");
  const ws_token = getCookie("ws_token");

  const handleVirtualCheckboxChange = () => {
    toggleVirtual();
    toggleLive();
    getSetting(broker, clientId, "SET", access_token, "virtual", "screenMode");
  };
  const handleLiveToggle = () => {
    if (broker === "gmail") {
      toggleLive.disabled = true;
    } else {
      toggleVirtual();
      toggleLive();
      getSetting(broker, clientId, "SET", access_token, "live", "screenMode");
    }
  };
  const handleLogout = () => {
    localStorage.clear();    
    // Check if current base URL is staging
    const currentBaseUrl = window.location.origin;
    if (currentBaseUrl === "https://staging-1lyapp.aliceblueonline.com") {
      window.location.href = "https://staging-1lyoptions.aliceblueonline.com/";
    } else {
      window.location.href = "https://1lyoptions.com/";
    }
  };

  useEffect(() => {
    const fetch = async () => {
      try {
        const data = await getSetting(broker, clientId, "GET", access_token);
        setSettingData(data);

        const storedMode = localStorage.getItem("initialTradeMode");
        if (broker === "gmail") {
          setIsVirtual(true);
          setIsLive(false);
          toggleLive.disabled = true;
          if (!storedMode) {
            localStorage.setItem("initialTradeMode", "virtual");
          }
        } else if (data && data.user_settings.trade_mode) {
          setIsLive(data.user_settings.trade_mode === "live");
          setIsVirtual(data.user_settings.trade_mode === "virtual");
        } else {
          setIsVirtual(true);
          setIsLive(false);
        }
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };

    fetch();
  }, []);

  return (
    <div className="fixed w-full top-0" style={{ zIndex: "999" }}>
      <div
        className="top-0 text-xs w-full text-center bg-[#12B16E] text-white"
        style={{ zIndex: "999" }}
        onClick={() => {
          window.location.href =
            "https://v1.1lyoptions.com/loginsuccess?authCode=" +
            auth_code +
            "&userId=" +
            clientId +
            "&ws_token=" +
            ws_token +
            "&access_token=" +
            access_token +
            "&broker=aliceblue";
        }}>
        The All New experience for 1lyoptions is here,{" "}
        <u className="cursor-pointer">Click here</u> if you wish to use the old
        version
      </div>
      <nav className="header w-full shadow-sm flex " style={{ zIndex: "999" }}>
        <div className="w-full mx-auto px-2 flex justify-between items-center">
          {/* Logo - Left aligned */}
          <Link className="flex items-center justify-center" to="/">
            <img src={lyoptions} alt="logo" className="app-logo" />
          </Link>

          {/* Center-aligned navigation links */}
          <ul className="flex flex-row items-center mx-auto space-y-0 space-x-8 ">
            <li className="text-xs font-medium nav-item">
              <CustomNavLink to="/">Strategy creator</CustomNavLink>
            </li>
            <li className="text-xs font-medium nav-item">
              <CustomNavLink to="/optionchain">Option chain</CustomNavLink>
            </li>
            <li className="text-xs font-medium nav-item">
              <CustomNavLink to="/positions">
                {isLive ? "Positions" : "Draft positions"}
              </CustomNavLink>
            </li>
            <li className="text-xs font-medium nav-item">
              <CustomNavLink to="/orders">
                {isLive ? "Orders" : "Draft orders"}
              </CustomNavLink>
            </li>
            <li className="text-xs font-medium nav-item">
              <CustomNavLink to="/scanners">Scanners</CustomNavLink>
            </li>
            <li className="text-xs font-medium nav-item">
              <CustomNavLink to="/charts">Charts</CustomNavLink>
            </li>
          </ul>

          {/* Right-aligned icons */}

          <div className="flex items-center gap-2">
            <img
              onClick={openModal}
              src={PdfIcon}
              alt="PDF Icon"
              style={{
                width: "32px",
                height: "32px",
              }}
              type="button"
            />
            <Link to="/discover">
              <img
                src={PullDownPageIcon}
                alt="Pull Down Page Icon"
                style={{
                  width: "32px",
                  height: "32px",
                }}
                type="button"
              />
            </Link>
            {/* User icon with dropdown functionality */}
            <div className="dropdown dropdown-bottom dropdown-end">
              <img
                src={UserIcon}
                alt="User Profile Pic"
                tabIndex={0}
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                }}
                className="dropdown"
                type="button"
                id="userDropdownMenu"
              />
              <ul
                tabIndex={0}
                className="dropdown-content z-[1] menu p-2 shadow bg-p400 rounded-md w-52 text-p300">
                <li>
                  <div className="flex items-center px-3 py-2 hover:text-p300">
                    <img
                      src={DropdownUserIcon}
                      alt="User Icon"
                      style={{
                        height: "16px",
                        width: "16px",
                        marginRight: "12px",
                        filter:
                          theme === "dark" ? "brightness(0) invert(1)" : "none",
                      }}
                    />
                    <span className="font-medium">
                      {BROKER_NAME === "gmail" ? gmailUserName : CLIENT_ID}
                    </span>
                    {BROKER_NAME === "gmail" && (
                      <>
                        <div className="ml-auto">
                          <button
                            className="p-0"
                            style={{
                              fontSize: "13px",
                              fontWeight: 600,
                              color: "#007bff",
                              textDecoration: "none",
                            }}
                            onClick={() => {
                              /* Add delete account function here */
                            }}>
                            Delete
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </li>
                <li>
                  {/* Calculators section */}
                  <div
                    className="flex items-center px-3 py-2  cursor-pointer hover:text-p300"
                    onClick={() => {
                      navigate("/calculators");
                    }}>
                    <img
                      src={CalculatorIcon}
                      alt="Calculator Icon"
                      style={{
                        width: "18px",
                        height: "18px",
                        marginRight: "12px",
                        filter:
                          theme === "dark" ? "brightness(0) invert(1)" : "none",
                      }}
                    />
                    <span className="font-medium">Calculators</span>
                  </div>
                </li>
                <li onClick={openReferModal}>
                  {/* Refer and earn - only for non-gmail */}
                  {BROKER_NAME !== "gmail" && (
                    <div className="flex items-center px-3 py-2 hover:text-p300">
                      <img
                        src={theme === "dark" ? ReferDarkIcon : ReferLightIcon}
                        alt="Refer Icon"
                        style={{
                          width: "18px",
                          height: "18px",
                          marginRight: "12px",
                        }}
                      />
                      <span className="font-medium">Refer and earn</span>
                    </div>
                  )}
                </li>

                <li>
                  {/* Theme toggle */}
                  <div className="pl-3 py-2 hover:text-p300">
                    <div className="flex justify-between items-center ">
                      <div className="flex items-center">
                        <img
                          src={theme === "dark" ? Moon : Sun}
                          alt="Theme Icon"
                          style={{
                            height: "18px",
                            width: "18px",
                            marginRight: "8px",
                            filter:
                              theme === "dark"
                                ? "brightness(0) invert(1)"
                                : "none",
                          }}
                        />
                        <span className="font-medium ml-3">
                          {theme === "dark" ? "Dark Mode" : "Light Mode"}
                        </span>
                      </div>

                      <div className="ml-2">
                        <input
                          type="checkbox"
                          className="theme-switch"
                          checked={theme === "dark"}
                          onChange={() =>
                            theme === "dark" ? setLightMode() : setDarkMode()
                          }
                        />
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  {/* Logout button */}
                  <div
                    className="flex items-center px-3 py-2 cursor-pointer hover:text-p300"
                    onClick={handleLogout}>
                    <img
                      src={LogoutIcon}
                      alt="Logout Icon"
                      style={{
                        width: "18px",
                        height: "18px",
                        marginRight: "12px",
                        filter:
                          theme === "dark" ? "brightness(0) invert(1)" : "none",
                      }}
                    />
                    <span className="font-medium">Logout</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <ReferAndEarnModal isOpen={showReferModal} onClose={closeReferModal} />
        <ReportsModal isOpen={isReportModalOpen} onClose={closeModal} />
      </nav>
    </div>
  );
};

export default HeaderDesktop;
